<template>
  <div class="tags_chart_container w50 left margin margin_r_hf margin_l_c">
    <tags-chart v-if="mainView === 'tags_chart'"></tags-chart>
  </div>
</template>

<script>
import hoursFormatterUtil from "@/mixins/system/hoursFormatterUtil";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import TagsChart from "../components/TagsChart.component";
import { mapGetters, mapState } from "vuex";

export default {
  name: "GraphTags.container",
  mixins: [hoursFormatterUtil, UsersPermissionCheck],
  components: {
    TagsChart
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("tasks", ["getChartQueryObject"]),
    ...mapState("tasks", ["queryForCharts", "resetQuery", "chartsViewBlocks"])
  },
  data() {
    return {
      mainView: 'tags_chart'
    };
  },
  mounted() {},
  watch: {
    chartsViewBlocks:function (){
      this.mainView = this.chartsViewBlocks[3];
    }

  },
  methods: {}
};
</script>

<style scoped>
/*.w50 {*/
/*  width: calc(50%);*/
/*}*/
.tags_chart_container {
  width: 44.8% !important;
}
.left {
  float: left;
}
</style>
